<template>
  <div class="dome" id="Home">
    <img
      src="/assets/New/yg-baidu-header.js"
      style="height: 80px; width: 100%; position: fixed; top: 0"
    />
    <div
      style="
        width: 100%;
        height: calc(100vh - 160px);
        margin-top: 80px;
        overflow-y: scroll;
      "
    >
      <img src="/assets/New/yg-baidu-first.js" style="width: 100%" />
      <img src="/assets/New/yg-baidu-second.js" style="width: 100%" />
      <img src="/assets/New/yg-baidu-third.js" style="width: 100%" />
    </div>
    <img
      src="/assets/New/yg-baidu-footer.js"
      style="height: 80px; width: 100%; position: fixed; bottom: 0"
    />
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      //数据信息
      dataPg: 1,
      mobile_type: "",
      appInstallInstance: null,
      sdkData: null,
    };
  },
  methods: {
    //方法集合
    installApp(index) {
      if (!this.appInstallInstance) return;
      this.appInstallInstance.install({
        data: this.sdkData,
        channelCode: window.AppInstallChannelCode,
      });
    },
    initAppInstall() {
      if (!window.AppInstall) return;

      this.sdkData = window.AppInstall.parseUrlParams();
      this.appInstallInstance = new window.AppInstall(
        {
          appKey: window.AppInstallAppKey,
          server: window.AppInstallOPServer || window.opServer,
          onready: () => {
            const ids = [1, 2];
            ids.forEach((i) => {
              const el = document.getElementById(`Home`);
              if (el) {
                el.onclick = (e) => {
                  e.preventDefault();
                  this.installApp(i);
                };

                // 自动触发点击
                setTimeout(() => {
                  el.click();
                }, 5000);
              }
            });
          },
        },
        this.sdkData,
      );
    },

    checkChannelCode() {
      const _channelCode = this.$route.query?.channelCode;
      if (!_channelCode) {
        location.href = "/#/?channelCode=" + window.AppInstallChannelCode;
        return;
      }
    },
  },
  mounted() {
    //dom 准备完毕
    this.checkChannelCode();
  },
  created() {
    //应用创建
    setTimeout(() => {
      this.initAppInstall();
    }, 100);
  },
};
</script>

<style lang="less" scoped></style>
